module.exports = __webpack_public_path__ + "media/images/hodzzy-cover-883e56154181961aa498adc303180a11.png";